// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"c3f06c49","433":"88806a13","579":"4ff1610b","589":"413126b5","772":"38914aa2"}[chunkId] + ".chunk.js";
};